import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('@@xver/project');

/** `projectId: null` = resolved without a project (no `X-Project-Id`, server default). */
export const setActiveProject = actionCreator<{ userId: number; projectId: string | null }>(
    'setActiveProject'
);
